export const GET_SKILLSETS = "GET_SKILLSETS";
export const ADD_SKILLSET = "ADD_SKILLSET";
export const EDIT_SKILLSET = "EDIT_SKILLSET";
export const GET_SKILLSET = "GET_SKILLSET";
export const RESET_SKILLSET = "RESET_SKILLSET";
export const ERROR_SKILLSET = "ERROR_SKILLSET";
export const GET_ALL_SKILLSETS = "GET_ALL_SKILLSETS";
                        